import _ from 'lodash'

const subscriptionPartnerCreateAccount = {
    restrict: 'E',
    bindings: {
        contractDraft: '<',
        sponsorValidation: '<',
        sponsorOkMessage: '<',
        promoValidation: '<',
        subscriptionType: '<',
        signupError: '<',
        choosenMESTariff: '<choosenMesTariff',
        isUpdating: '<',
        powerMax: '<',
        partnerOffer: '<',
        onCreateAccount: '&',
    },
    template: require('./subscriptionPartnerCreateAccount.jade')(),
    /** @ngInject */ controller($element, $location, DeviceChecker, MobilePhone, RecaptchaKey, ContactTelephone) {
        const ctrl = this
        ctrl.isMobile = DeviceChecker.isMobile
        ctrl.contactTelephone = ContactTelephone
        ctrl.phoneRegex = MobilePhone.phoneRegex.all
        ctrl.newUser = {
            captcha: undefined,
        }
        ctrl.captcha = {
            key: RecaptchaKey[$location.host()],
        }

        ctrl.isPromoValid = () => ctrl.promoValidation.isValid
    },
}

export default subscriptionPartnerCreateAccount



// WEBPACK FOOTER //
// ./src/states/subscription/component/subscriptionPartnerCreateAccount.js